import React, { useRef } from 'react';
import { ArrowRight, ShieldCheck, Heart } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden pt-16 pb-20 bg-stone-50/50" data-id="element-798">
      {/* Background Image - Main */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1587300003388-59208cc962cb?q=80&w=2070&auto=format&fit=crop)'
    }} data-id="element-799"></div>

      {/* Vibrant Gradient Blobs */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-amber-400/15 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/3 animate-pulse" data-id="element-800"></div>
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-teal-400/15 rounded-full blur-[100px] translate-y-1/3 -translate-x-1/4" data-id="element-801"></div>
      <div className="absolute top-1/2 left-1/2 w-[400px] h-[400px] bg-amber-300/10 rounded-full blur-[80px] -translate-x-1/2 -translate-y-1/2" data-id="element-802"></div>

      {/* Floating Images */}
      <div className="hidden lg:block absolute bottom-20 right-10 w-56 h-56 rounded-full overflow-hidden shadow-2xl rotate-[6deg] hover:rotate-0 transition-transform duration-500 border-4 border-white" data-id="element-803">
        <img src="https://images.unsplash.com/photo-1530281700549-e82e7bf110d6?q=80&w=500&auto=format&fit=crop" alt="Happy dog running" className="w-full h-full object-cover" data-id="element-804" />
      </div>
      <div className="hidden lg:block absolute top-32 right-20 w-32 h-32 rounded-2xl overflow-hidden shadow-xl rotate-[12deg] hover:rotate-0 transition-transform duration-500 border-4 border-white" data-id="element-805">
        <img src="https://images.unsplash.com/photo-1623366302587-b38b1ddaefd9?q=80&w=500&auto=format&fit=crop" alt="Fresh ingredients" className="w-full h-full object-cover" data-id="element-806" />
      </div>
      <div className="hidden lg:block absolute bottom-32 left-24 w-24 h-24 rounded-full overflow-hidden shadow-lg -rotate-[12deg] hover:rotate-0 transition-transform duration-500 border-4 border-white bg-green-100 flex items-center justify-center" data-id="element-807">
        <span className="text-4xl" data-id="element-808">🥦</span>
      </div>

      <div className="container mx-auto px-4 relative z-10 text-center max-w-5xl" data-id="element-809">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 text-white px-5 py-2.5 rounded-full mb-8 border-2 shadow-lg hover:scale-105 transition-transform animate-pulse" style={{
        backgroundColor: '#C0392B',
        borderColor: '#a93226'
      }} data-id="element-810">
          <ShieldCheck className="w-5 h-5" data-id="element-811" />
          <span className="text-sm font-bold tracking-wide uppercase" data-id="element-812">
            ⚠️ ATENCIÓN, DUEÑO DE MASCOTA
          </span>
        </div>

        {/* Main Heading */}
        <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-6 leading-tight tracking-tight drop-shadow-sm" data-id="element-813">
          La picazón, el lamido, la caída del pelo, los vómitos y las heces
          blandas{' '}
          <span className="relative" style={{
          color: '#C0392B'
        }} data-id="element-814">
            no son normales.
            <svg className="absolute w-full h-3 -bottom-1 left-0 -z-10" viewBox="0 0 100 10" preserveAspectRatio="none" style={{
            color: '#e8a89e'
          }} data-id="element-815">
              <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="8" fill="none" data-id="element-816" />
            </svg>
          </span>
        </h1>

        <p className="text-xl text-gray-700 mb-6 font-medium inline-block px-4 py-2 rounded-lg" style={{
        backgroundColor: '#FFF3E0'
      }} data-id="element-817">
          Su mascota podría estar desarrollando una afección grave sin que usted
          lo sepa.
        </p>

        {/* Subheading */}
        <div className="backdrop-blur-sm p-6 rounded-2xl border-2 shadow-lg max-w-4xl mx-auto mb-10 relative overflow-hidden" style={{
        background: 'linear-gradient(to right, #FFF3E0, #F8F6F1)',
        borderColor: '#6DAA7F'
      }} data-id="element-818">
          <div className="absolute top-0 right-0 w-24 h-24 rounded-full blur-2xl opacity-30 -translate-y-1/2 translate-x-1/2" style={{
          backgroundColor: '#6DAA7F'
        }} data-id="element-819"></div>
          <p className="text-lg md:text-xl font-bold mb-3 relative z-10" style={{
          color: '#2F5D50'
        }} data-id="element-820">
            🩺 Un veterinario que realizó estudios por más de 18 años en Brasil,
            reveló:
          </p>
          <p className="text-lg text-gray-700 leading-relaxed relative z-10" data-id="element-821">
            El{' '}
            <span className="text-white px-2 py-0.5 rounded-md font-bold" style={{
            backgroundColor: '#2F5D50'
          }} data-id="element-822">
              Programa Clínico de Nutrición Natural para Perros
            </span>{' '}
            capaz de frenar la inflamación silenciosa, salvar la vida de tu
            mascota y{' '}
            <span className="font-bold" style={{
            color: '#C0392B'
          }} data-id="element-823">
              aumentar su esperanza de vida hasta 7 años.
            </span>
          </p>
        </div>

        {/* CTA Area */}
        <div className="flex flex-col items-center gap-4 mb-8" data-id="element-824">
          {/* Audio Player */}
          <div className="w-full max-w-xl rounded-2xl px-5 py-4 flex items-center gap-4 relative overflow-hidden" style={{
          background: 'linear-gradient(135deg, #2F5D50 0%, #3d7a68 40%, #4a9680 70%, #2F5D50 100%)',
          boxShadow: '0 0 24px 6px rgba(47,93,80,0.4), 0 0 8px 2px rgba(47,93,80,0.3)',
          animation: 'audioGlow 2.5s ease-in-out infinite'
        }} data-id="element-825">
            <span className="pointer-events-none absolute inset-0 rounded-2xl" style={{
            background: 'linear-gradient(105deg, transparent 35%, rgba(255,255,255,0.18) 50%, transparent 65%)',
            animation: 'shimmerSweep 2.8s linear infinite'
          }} data-id="element-826" />
            <style data-id="element-827">{`
              @keyframes audioGlow {
                0%, 100% { box-shadow: 0 0 20px 4px rgba(47,93,80,0.45), 0 0 8px 2px rgba(47,93,80,0.35); }
                50% { box-shadow: 0 0 36px 10px rgba(47,93,80,0.75), 0 0 14px 4px rgba(47,93,80,0.55); }
              }
              @keyframes shimmerSweep {
                0% { transform: translateX(-100%); }
                100% { transform: translateX(200%); }
              }
            `}</style>
            <div className="w-11 h-11 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 shadow-md border border-white/30 relative z-10" data-id="element-828">
              <span className="text-xl" data-id="element-829">🎧</span>
            </div>
            <div className="flex-1 min-w-0 relative z-10" data-id="element-830">
              <p className="text-xs font-extrabold text-white uppercase tracking-widest mb-1.5 drop-shadow" data-id="element-831">
                🔊 Mensaje importante
              </p>
              <audio controls className="w-full h-8" style={{
              accentColor: '#fff'
            }} data-id="element-832">
                <source src="https://ydgkmdmvhrniztrhtrxq.supabase.co/storage/v1/object/sign/audio%20receta/freepik__si-tu-mascota-presenta-alguno-de-estos-s_ntomas_-es-importante-que-prestes-atenci__2235.mp3?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV80NDNkYTY1ZS1iYWM1LTQyYWQtODMzNS1iNWE4N2M0NDYxNmQiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJhdWRpbyByZWNldGEvZnJlZXBpa19fc2ktdHUtbWFzY290YS1wcmVzZW50YS1hbGd1bm8tZGUtZXN0b3Mtc19udG9tYXNfLWVzLWltcG9ydGFudGUtcXVlLXByZXN0ZXMtYXRlbmNpX18yMjM1Lm1wMyIsImlhdCI6MTc3MjI0OTg3NiwiZXhwIjoxODAzNzg1ODc2fQ.AgpW4Q62gMYLuNOsBFqze4R2cYz2u4XBUwSw38m1UGk" type="audio/mpeg" data-id="element-833" />
                Tu navegador no soporta el elemento de audio.
              </audio>
            </div>
          </div>

          {/* CTA Button - always active */}
          <button onClick={() => {
          document.getElementById('pattern-section')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }} className="group relative text-white text-lg md:text-2xl font-bold py-6 px-12 rounded-2xl shadow-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl flex items-center gap-3 overflow-hidden text-center leading-tight" style={{
          background: 'linear-gradient(to right, #F57C00, #e07000)',
          boxShadow: '0 10px 30px rgba(245,124,0,0.35)'
        }} onMouseEnter={e => e.currentTarget.style.background = 'linear-gradient(to right, #E66A00, #cc5f00)'} onMouseLeave={e => e.currentTarget.style.background = 'linear-gradient(to right, #F57C00, #e07000)'} data-id="element-834">
            <span className="relative z-10 flex items-center gap-3" data-id="element-835">
              QUIERO SALVAR LA VIDA DE MI MASCOTA AHORA
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform hidden md:block" strokeWidth={3} data-id="element-836" />
            </span>
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 skew-y-12" data-id="element-837"></div>
          </button>
        </div>

        <div className="flex items-center gap-2 text-sm text-gray-500 font-medium justify-center" data-id="element-838">
          <div className="flex -space-x-2" data-id="element-839">
            {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full border-2 border-white bg-gray-200 overflow-hidden" data-id="element-840">
                <img src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="User" className="w-full h-full object-cover" data-id="element-841" />
              </div>)}
          </div>
          <div className="flex items-center gap-1" data-id="element-842">
            <div className="flex text-yellow-400" data-id="element-843">
              {[1, 2, 3, 4, 5].map(i => <Heart key={i} className="w-4 h-4 fill-current" data-id="element-844" />)}
            </div>
            <span className="text-gray-600" data-id="element-845">+1,200 dueños felices</span>
          </div>
        </div>
      </div>
    </section>;
}